/*
 *------------------------------------------------------------------
 * App.js
 *
 * Renders the App component.
 *
 * June 2020, Rohith Raj S
 *
 * Copyright (c) 2020-2023 by Cisco Systems, Inc.
 * All rights reserved.
 *------------------------------------------------------------------
 */

import React from "react";
import "./App.css";
import Content from "./components/Content";

function App() {
  return (
    <div className="App">
      <Content/>
    </div>
  );
}

export default App;
